import { FIELD_STATE_STYLES, FieldState } from './field-styles-config'

export function fillOpacity(state: FieldState) {
  const opacity = FIELD_STATE_STYLES[state].fillOpacity
  return Math.round(Math.min(1, Math.max(0, opacity)) * 255)
    .toString(16)
    .toUpperCase()
    .padStart(2, '0')
}

export const LEGENDS_CONFIG = {
  disabled: {
    label: 'Talhões sem dados suficientes',
    backgroundColor: `${FIELD_STATE_STYLES.disabled.fillColor}${fillOpacity(
      'disabled',
    )}`,
    border: `solid ${FIELD_STATE_STYLES.disabled.weight}px`,
    borderColor: FIELD_STATE_STYLES.disabled.color,
    opacity: FIELD_STATE_STYLES.disabled.opacity,
  },
  enabled: {
    label: 'Talhões com 2 ou mais diagnósticos',
    backgroundColor: `${FIELD_STATE_STYLES.enabled.fillColor}${fillOpacity(
      'enabled',
    )}`,
    border: `solid ${FIELD_STATE_STYLES.enabled.weight}px`,
    borderColor: FIELD_STATE_STYLES.enabled.color,
    opacity: FIELD_STATE_STYLES.enabled.opacity,
  },
}

export const getAllLegends = () => {
  return Object.entries(LEGENDS_CONFIG).map(([key, config]) => ({
    key: key as keyof typeof LEGENDS_CONFIG,
    ...config,
  }))
}
